import UniversityDashboard from "../../coach/dashboard/CoachDashboard";

function HighSchoolDashboardPage() {
  return <UniversityDashboard />;
}

export default HighSchoolDashboardPage;
